import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, DatePicker, Drawer, Input, Modal } from 'antd';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import moment from 'moment';
import isHoliday from '../../../constants/holidays';
import UploadArquivo from '../../molecules/UploadArquivo';
import { requisicaoProps } from '../../atoms/Props';
import { useUserPolicy } from '../../../user-policy';

const { TextArea } = Input;

function DrawerFinalizacao({ visible, onOk, onCancel, loading, requisicao }) {
  const [dataPrevista, setDataPrevista] = useState(undefined);
  const [dataPrevistaFatura, setDataPrevistaFatura] = useState(undefined);
  const [observacao, setObservacao] = useState(undefined);
  const { userAccount } = useUserPolicy();

  useEffect(() => {
    if (requisicao) {
      setDataPrevista(undefined);
      setDataPrevistaFatura(undefined);
      setObservacao(undefined);
    }
  }, [requisicao]);

  const canFinish = () => {
    if (dataPrevistaFatura >= dataPrevista) {
      return Modal.warning({
        title: 'Data de Vencimento Previsto da Fatura',
        content: 'A Data de Vencimento Previsto da Fatura deve ser menor que a data de Pagamento ao Cooperado.',
      });
    }
    return onOk(dataPrevista, dataPrevistaFatura, observacao);
  };

  const isDisabledDayToPayment = (current) => {
    if (!userAccount.isAdmin && isHoliday(current)) return true;
    if (current.isAfter(moment().add(3, 'months'))) {
      return true;
    }
    const diasAntes = current && (current.isBefore(moment.utc()) || moment.utc() === current);
    const finaisDeSemana = current && (moment(current).day() === 6 || moment(current).day() === 0);
    return diasAntes || finaisDeSemana;
  };

  const diasAnterioresEAposRepasse = (current) => {
    const diasAntEAposRepasse =
      current && (current.isBefore(moment().subtract(1, 'days')) || current.isAfter(dataPrevista));
    const finaisDeSemana = current && (moment(current).day() === 6 || moment(current).day() === 0);
    return diasAntEAposRepasse || finaisDeSemana;
  };

  return (
    <Drawer
      title="Processar Apontamento"
      width={450}
      placement="right"
      closable={false}
      onClose={() => onCancel()}
      open={visible}
      keyboard={false}
      maskClosable={false}
    >
      <h3>Data de pagamento ao Cooperado *</h3>
      <p>É necessário informar a data para pagamento ao Cooperado.</p>

      <DatePicker
        allowClear={false}
        placeholder="DD/MM/YYYY"
        format="DD/MM/YYYY"
        value={dataPrevista}
        disabledDate={isDisabledDayToPayment}
        onChange={(data) => {
          setDataPrevista(data);
          setDataPrevistaFatura(undefined);
        }}
        showToday={false}
        style={{ marginTop: '8px', marginBottom: '32px' }}
      />

      <h3>Vencimento Previsto da Fatura</h3>
      <p>
        Obs.: Ao preencher, solicitamos que atente-se ao prazo de 6 (seis) dias, a contar de hoje, para que todos os
        processos sejam cumpridos com qualidade.
      </p>

      <DatePicker
        allowClear={false}
        placeholder="DD/MM/YYYY"
        format="DD/MM/YYYY"
        value={dataPrevistaFatura}
        onChange={(data) => {
          setDataPrevistaFatura(data);
        }}
        style={{ marginTop: '8px', marginBottom: '32px' }}
        disabledDate={diasAnterioresEAposRepasse}
      />

      <h3>Adicionar Observação (Opcional)</h3>
      <p>Envie suas informações/observações para a Folha.</p>

      <TextArea
        placeholder="Insira aqui uma observação ou comentário"
        style={{
          marginTop: '8px',
          marginBottom: '32px',
          overflow: 'auto',
          resize: 'none',
        }}
        rows={6}
        value={observacao}
        maxLength={65000}
        type="text"
        onChange={(e) => setObservacao(e.target.value)}
      />

      <UploadArquivo
        files={requisicao.anexos}
        requisicao={requisicao}
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          gap: '10px',
          marginTop: '32px',
        }}
      >
        <Button
          key="submit"
          type="primary"
          onClick={() => canFinish()}
          loading={loading}
          disabled={!dataPrevista || !dataPrevistaFatura}
        >
          <CustomText color="white">Finalizar Apontamento</CustomText>
        </Button>

        <Button
          key="back"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
      </div>
    </Drawer>
  );
}

DrawerFinalizacao.propTypes = {
  visible: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  requisicao: requisicaoProps,
};

DrawerFinalizacao.defaultProps = {
  visible: false,
  requisicao: {},
};

export default DrawerFinalizacao;
